<template>
  <!-- 拜访记录详情 -->
  <div class="visit-detail record-detail" v-loading="loading">
    <div class="info-row">
      <div class="info-row-item">
        <span class="row-label">拜访人</span>
        <span class="row-value">{{ currentRecordInfo.creatorName || '-' }}</span>
      </div>
    </div>
    <!-- 拜访时间 -->
    <div
      v-if="(showFormFieldKeyInfo.visit_time_formCode_FR014 || {}).isShow"
      class="info-row"
    >
      <div class="info-row-item">
        <span class="row-label">{{ showFormFieldKeyInfo.visit_time_formCode_FR014.zhName }}</span>
        <span class="row-value">{{ formData.visit_time_formCode_FR014 || '-' }}</span>
      </div>
    </div>
    <!-- 拜访方式 -->
    <div
      v-if="(showFormFieldKeyInfo.visit_type_formCode_FR014 || {}).isShow"
      class="info-row"
    >
      <div class="info-row-item">
        <span class="row-label">{{ showFormFieldKeyInfo.visit_type_formCode_FR014.zhName }}</span>
        <span class="row-value">
          {{ formData.visit_type_formCode_FR014.map(item => item.questionItemLabel).join(',') || '-' }}
        </span>
      </div>
    </div>
    <!-- 现场照片 -->
    <div
      v-if="(showFormFieldKeyInfo.picture_formCode_FR014 || {}).isShow"
      class="info-row"
    >
      <div class="info-row-item block">
        <span class="row-label">{{ showFormFieldKeyInfo.picture_formCode_FR014.zhName }}</span>
        <div class="image-list">
          <el-image
            v-for="(img, idx) in formData.picture_formCode_FR014"
            :key="idx"
            :src="img"
            :preview-src-list="formData.picture_formCode_FR014"
            class="info-image"
            fit="cover"
          />
          <div v-if="(formData.picture_formCode_FR014 || []).length === 0" class="empty">暂无图片</div>
        </div>
      </div>
    </div>
    <!-- 医生需求 -->
    <div
      v-if="(showFormFieldKeyInfo.feedback_formCode_FR014 || {}).isShow"
      class="info-row"
    >
      <div class="info-row-item">
        <span class="row-label">{{ showFormFieldKeyInfo.feedback_formCode_FR014.zhName }}</span>
        <span class="row-value">{{ formData.feedback_formCode_FR014 || '-' }}</span>
      </div>
    </div>
    <!-- 是否产生费用 -->
    <div
      v-if="(showFormFieldKeyInfo.is_fee_formCode_FR014 || {}).isShow"
      class="info-row"
    >
      <div class="info-row-item">
        <span class="row-label">{{ showFormFieldKeyInfo.is_fee_formCode_FR014.zhName }}</span>
        <span class="row-value">{{ formData.is_fee_formCode_FR014.map(item => item.questionItemLabel).join(',') || '-' }}</span>
      </div>
    </div>
    <!-- 拜访费用 -->
    <div
      v-if="(showFormFieldKeyInfo.visit_fee_formCode_FR014 || {}).isShow"
      class="info-row"
    >
      <div class="info-row-item">
        <span class="row-label">{{ showFormFieldKeyInfo.visit_fee_formCode_FR014.zhName }}</span>
        <span class="row-value">{{ formData.visit_fee_formCode_FR014 || '-' }}{{ showFormFieldKeyInfo.visit_fee_formCode_FR014.unit }}</span>
      </div>
    </div>
    <!-- 费用明细 -->
    <div
      v-if="(showFormFieldKeyInfo.feed_detail_formCode_FR014 || {}).isShow"
      class="info-row"
    >
      <div class="info-row-item">
        <span class="row-label">{{ showFormFieldKeyInfo.feed_detail_formCode_FR014.zhName }}</span>
        <span class="row-value">{{ formData.feed_detail_formCode_FR014 || '-' }}</span>
      </div>
    </div>
    <!-- 上传附件 -->
    <div
      v-if="(showFormFieldKeyInfo.attr_formCode_FR014 || {}).isShow"
      class="info-row"
    >
      <div class="info-row-item block">
        <span class="row-label">{{ showFormFieldKeyInfo.attr_formCode_FR014.zhName }}</span>
        <div class="image-list">
          <el-image
            v-for="(img, idx) in formData.attr_formCode_FR014"
            :key="idx"
            :src="img"
            :preview-src-list="formData.attr_formCode_FR014"
            class="info-image"
            fit="cover"
          />
          <div v-if="(formData.attr_formCode_FR014 || []).length === 0" class="empty">暂无附件</div>
        </div>
      </div>
    </div>
    <!-- 备注 -->
    <div
      v-if="(showFormFieldKeyInfo.remark_formCode_FR014 || {}).isShow"
      class="info-row"
    >
      <div class="info-row-item">
        <span class="row-label">{{ showFormFieldKeyInfo.remark_formCode_FR014.zhName }}</span>
        <span class="row-value">{{ formData.remark_formCode_FR014 || '-' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/views/DoctorVisitLTC/utils/index'
import formFlow from '@/views/DoctorVisitLTC/common/formFlow'

const visitFormCode = 'FR014' // 访问记录表单编码

export default {
  name: 'VisitDetail',
  data() {
    return {
      loading: false,
      originOptionsInfo: {},
      showFormFieldKeyInfo: {},
      formData: {
        visit_time_formCode_FR014: '', // 拜访时间
        visit_id_formCode_FR014: '', // 拜访id
        visit_type_formCode_FR014: '', // 拜访方式
        feedback_formCode_FR014: '', // 医生需求
        picture_formCode_FR014: [], // 图片地址列表
        is_fee_formCode_FR014: [], // 是否产生费用
        visit_fee_formCode_FR014: '', // 拜访费用
        feed_detail_formCode_FR014: '', // 费用明细
        attr_formCode_FR014: [], // 上传附件
        remark_formCode_FR014: '' // 备注
      },
    }
  },
  methods: {
    async init(formCodeList) {
      this.loading = true
      try {
        await this.getFormFieldList(formCodeList)
        await this.getFormData(formCodeList)
      } catch (error) {
        console.error('获取表单字段配置信息失败', error)
      } finally {
        this.loading = false
      }
    },

    async getFormFieldList(formCodeList = []) {
      const {
        formData,
        showFormFieldKeyInfo,
        originOptionsInfo
      } = await formFlow.getFormFieldList(formCodeList)

      this.formData = formData
      this.showFormFieldKeyInfo = showFormFieldKeyInfo
      this.originOptionsInfo = originOptionsInfo
    },

    // 获取表单数据
    async getFormData(formCodeList = []) {
      const { formData } = this
      for (const formCode of formCodeList) {
        const data = await formFlow.getFormData({
          instanceId: this.currentRecordInfo.doctorStageId,
          stepCode: this.currentRecordInfo.stepCode,
          stepId: this.currentRecordInfo.stepId,
          formCode,
          doctorId: this.currentRecordInfo.doctorId,
          interfaceType: 'stepId',
          formDataId: this.currentRecordInfo.visitId
        })
        // console.log('获取详情页面表单页面数据', data)
      
        // 表单获取的数据为空，则初始化表单id
        if (utils.getDataType(data) === 'object' && Object.keys(data.formData).length === 0) {
          continue
        }

        for(const key in data.formData) {
          const item = data.formData[key] || {}
          const valueList = utils.getDataType(item.value) === 'array' ? item.value : []
          if (key === 'picture_formCode_FR014' || key === 'attr_formCode_FR014') {
            // 图片
            formData[key] = valueList.map(item => this.imageBaseUrl + item || '')
          } else {
            if ([1, 2].includes(item.inputType)) {
              // 单选/多选
              formData[key] = (this.originOptionsInfo[key] || []).filter(item => valueList.includes(item.questionItemValue))
            } else {
              formData[key] = valueList[0] || formData[key] || ''
            }
          }
        }
        this.formData = formData
      }
    },
  },
  created() {
    const formCodeList = [visitFormCode]
    this.init(formCodeList)
  },
  props: {
    currentRecordInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    imageBaseUrl() {
      return process.env.VUE_APP_ENV === 'production' ? 'https://image.scxinglin.com' : 'https://testdev.scxinglin.com'
      // return 'https://image.scxinglin.com'
    }
  }
}

</script>

<style scoped lang='less'>
@import '~@/views/DoctorVisitLTC/style/recordDetail.less';

.visit-detail {
  .row-label {
    width: 90px !important;
  }
}
</style>